var _circle, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseNavbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#334660"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.8552,
    y: 13.0002,
    width: 0.873576,
    height: 32.3223,
    transform: "rotate(45 35.8552 13.0002)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1882,
    y: 13.6177,
    width: 0.873576,
    height: 32.3223,
    transform: "rotate(-45 13.1882 13.6177)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNavbar);
export default __webpack_public_path__ + "static/media/close-navbar.d7263358a49d69e8561d3fbf75dcffde.svg";
export { ForwardRef as ReactComponent };